import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  // {
  //   path: "/",
  //   name: "home",
  //   component: () => import(/* webpackChunkName: "Home" */ "../views/Home")
  // },
  // {
  //   path: "/portfolio",
  //   name: "portfolio",
  //   meta: { title: 'Portfolio' },
  //   component: () =>
  //     import(/* webpackChunkName: "Portfolio" */ "../views/Portfolio")
  // },
  // {
  //   path: "/portfolio/:slug",
  //   name: "PortfolioDetail",
  //   meta: { title: 'Portfolio' },
  //   component: () => import(/* webpackChunkName: "PortfolioDetail" */ "../views/PortfolioDetail"),
  //   props: true,
  // },
  {
    path: "/",
    alias: '/film',  // Backward compatibility
    name: "film",
    meta: { title: 'Houqi\'s Film Collection' },
    component: () =>
      import(/* webpackChunkName: "Film" */ "../views/Film")
  },
  {
    path: "/zh/film",
    alias: '/film-zh',   // Backward compatibility
    name: "zh-film",
    meta: { title: 'Houqi电影列表' },
    component: () =>
      import(/* webpackChunkName: "FilmChinese" */ "../views/FilmChinese")
  },
  // {
  //   path: "/fr/film",
  //   alias: '/film-fr',   // Backward compatibility
  //   name: "fr-film",
  //   meta: { title: 'Liste des films' },
  //   component: () =>
  //     import(/* webpackChunkName: "FilmFrench" */ "../views/FilmFrench")
  // },
  {
    path: "/recommend-a-film",
    name: "recommend-a-film",
    meta: { title: 'Recommend a Film' },
    component: () =>
      import(/* webpackChunkName: "RecommendAFilm" */ "../views/RecommendAFilm")
  },
  {
    path: "/zh/recommend-a-film",
    name: "zh-recommend-a-film",
    meta: { title: '推荐一部电影' },
    component: () =>
      import(/* webpackChunkName: "RecommendAFilmChinese" */ "../views/RecommendAFilmChinese")
  },
  // {
  //   path: "/fr/recommend-a-film",
  //   name: "fr-recommend-a-film",
  //   meta: { title: 'Recommander un Film' },
  //   component: () =>
  //     import(/* webpackChunkName: "RecommendAFilmFrench" */ "../views/RecommendAFilmFrench")
  // },
  // {
  //   path: "/tell-me",
  //   name: "tell-me",
  //   meta: { title: 'Contact' },
  //   component: () =>
  //     import(/* webpackChunkName: "TellMe" */ "../views/TellMe")
  // },
  {
    path: "/404",
    alias: "*",
    name: "NotFound",
    meta: { title: '404' },
    component: () =>
      import(/* webpackChunkName: "NotFound" */ "../views/NotFound")
  }
];

const router = new VueRouter({
  // mode: "history",
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});

export default router;
